import {Pages} from 'shared/config/model/pages';

import React from 'react';
import {i18n} from '@lingui/core';
import {t} from '@lingui/core/macro';

import {locationAPI} from 'entities/location';
import {getPollingInterval} from 'shared/api/pollingHelper';
import useListParams from 'shared/lib/hooks/useListParams';

import {LOCATION_FILTER_KEYS} from '../../lib/adminFilterKeys';
import AdminListScreen from '../AdminList/AdminListScreen/AdminListScreen';
import AdminCreateButton from '../AdminList/AdminCreateButton';
import LocationRow from './LocationRow';
import LocationsModal from './LocationsModal';
import LocationsFiltersForm from './LocationsFiltersForm/LocationsFiltersForm';

const Locations: React.FC = () => {
    const params = useListParams({filterKeys: LOCATION_FILTER_KEYS});
    const query = locationAPI.useGetLocationsQuery(params.args, {pollingInterval: getPollingInterval()});

    return (
        <AdminListScreen
            title={t`Локации`}
            heading={i18n._(Pages.LOCATIONS)}
            createButton={<AdminCreateButton label={t`Добавить локацию`} Modal={LocationsModal}/>}
            columns={[
                {label: 'ID'},
                {label: 'Название'},
                {label: 'Страна'},
                {label: 'Зона'},
                {label: 'Город'},
                {label: 'Статус'},
                {label: 'IP'},
                {label: ''},
            ]}
            params={params}
            query={query}
            rowFactory={item => <LocationRow key={item.id} item={item}/>}
            FiltersForm={LocationsFiltersForm}
        />
    );
};

export default React.memo(Locations);
